import { FC } from 'react'
import { IconPaths, KTSVG } from '_metronic/helpers'

type Props = {
  titulo: string
  itens: string[]
  /** `id` para ligar o bloco ao campo via `aria-describedby`. */
  id?: string
}

/**
 * Lista, junto ao campo, os itens que o backend recusou no 422
 * (`errors.vinculos`) — um por linha, com o motivo que veio da API.
 *
 * Existe para atender ao critério "empresa ou especialidade descartada por falta
 * de vínculo é informada ao usuário, não silenciada": antes desta fatia o
 * `processaVinculos()` descartava em silêncio e o usuário montava escala
 * achando que cobriu três empresas e cobriu duas. Toast genérico não resolve —
 * a informação precisa ficar ao lado do campo que a gerou.
 */
export const ErrosVinculos: FC<Props> = ({ titulo, itens, id }) => {
  if (!itens.length) return null

  return (
    <div id={id} className='alert alert-danger d-flex align-items-start mb-5' role='alert'>
      <KTSVG path={IconPaths.Warning} className='svg-icon-em fs-4 me-3 mt-1' ariaHidden />
      <div>
        <strong className='d-block mb-1'>{titulo}</strong>
        <ul className='mb-0 ps-4'>
          {itens.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
